import filterModal from './FilterModal/texts.js';

export default {
  filterModal,
};
